(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.controller('HelpController', ['helpList', 'HelpCategoryEnum', 'HelpService', HelpControllerFn]);

    /* controlle for help */
    function HelpControllerFn(helpList, HelpCategoryEnum, HelpService) {
        var vm = this;

        vm.helpCategories = [];
        vm.searchValue = "";

        // filtered list
        vm.filteredList = [];

        activate();

        // search by content
        vm.search = function () {
            if (vm.searchValue) {
                vm.filteredList = [];

                // search and filter result
                HelpService.search(vm.searchValue).then(function (result) {
                    if (result) {
                        var i = 0;
                        var len = helpList.length;
                        for (i; i < len; i++) {
                            // filter by result
                            var j = 0;
                            var rlen = result.length;
                            for (j; j < rlen; j++) {
                                if (helpList[i].id === result[j]) {
                                    vm.filteredList.push(helpList[i]);
                                } // if
                            } // for
                        } // for
                    }
                });
            } // if
        };

        /* activation work */
        function activate() {
            vm.helpCategories = HelpCategoryEnum;
            vm.filteredList = helpList;
        }
    }
})();
